module.exports = __webpack_public_path__ + "media/theme/blog__border-11-57857267.png";